// SPDX-License-Identifier: AGPL-3.0-or-later

/** Max characters for a guild server tag name (letters/digits only). */
export const SERVER_TAG_NAME_MAX_LENGTH = 4;

/** Allowed badge catalog ids for guild server tags. */
export const SERVER_TAG_BADGE_IDS = [
	'leaf',
	'sword',
	'heart',
	'flame',
	'droplet',
	'skull',
	'moon',
	'bolt',
	'gem',
	'mushroom',
	'star',
	'crown',
	'rose',
	'paw',
	'shield',
	'rocket',
	'music',
	'sparkle',
	'anchor',
	'coffee',
] as const;

export type ServerTagBadgeId = (typeof SERVER_TAG_BADGE_IDS)[number];

export const SERVER_TAG_DEFAULT_BADGE_ID: ServerTagBadgeId = 'sword';
export const SERVER_TAG_DEFAULT_COLOR = 0xf47fff;

const SERVER_TAG_BADGE_ID_SET = new Set<string>(SERVER_TAG_BADGE_IDS);

export function isServerTagBadgeId(value: string): value is ServerTagBadgeId {
	return SERVER_TAG_BADGE_ID_SET.has(value);
}

export function normalizeServerTagName(value: string): string {
	return value
		.toUpperCase()
		.replace(/[^A-Z0-9]/g, '')
		.slice(0, SERVER_TAG_NAME_MAX_LENGTH);
}

export function isValidServerTagName(value: string): boolean {
	return /^[A-Z0-9]{1,4}$/.test(value);
}
